{
  "page": {
    "title": "Setup",
    "get_started": {
      "greeting": "Welcome!",
      "info": "Thank you for choosing Scalefield.\nIn this setup wizard, we'll take you through the essential steps for you to get started deploying your clusters."
    },
    "superuser": {
      "title": "Administrator account",
      "description": "The Scalefield administrator account grants full control over the Scalefield instance, including organization creation, configuring settings and security."
    },
    "organization": {
      "title": "Organization",
      "description": "In Scalefield, an Organization is your central hub for managing projects, services, and teams. It streamlines resource management, access control, and collaboration, ensuring efficient teamwork.",
      "fields": {
        "organization_name": "Organization Name",
        "address_line_1": "Street Address"
      }
    },
    "email_configuration": {
      "title": "Email Configuration",
      "description": "The email configuration in Scalefield is crucial for enabling the platform to send out notifications to users.",
      "test_email_info": "An email will be sent to your administrator account address"
    },
    "buttons": {
      "get_started": "Get started",
      "skip": "Skip",
      "submit": "Next",
      "test_email": "Send test email"
    }
  }
}
